<template>
    <div v-if="!loading" class="past-analysis-slider overflow-x-hidden">
        <div class="flex flex-row justify-between items-center mb-8">
            <strong>{{ $t('Past Analysis') }}</strong>
            <div class="flex flex-row justify-end gap-4">
                <div class="past-analysis-button-prev text-blue cursor-pointer">
                    <Icon type="TailLeft" viewBox="0 0 30 21" width="25" height="26" fill="none" class="stroke-current" />
                </div>
                <div class="past-analysis-button-next text-blue cursor-pointer">
                    <Icon type="TailRight" viewBox="0 0 30 21" width="25" height="26" fill="none" class="stroke-current" />
                </div>
            </div>
        </div>

        <div v-if="getByKey('past_analysis').data.length > 0" class="swiper-wrapper" style="height: max-content">
            <div v-for="analysis in getByKey('past_analysis').data" :key="analysis.id" class="swiper-slide">
                <SingleContentstream
                    v-if="origin === 'contentstreams'"
                    class="block"
                    :data="analysis"
                    :page="page"
                    :query_params="query_params"
                    :active_tab="active_tab"
                    :type="type"
                />
                <SingleVideoAnalysis v-else class="block" :data="analysis" :page="page" :query_params="query_params" :active_tab="active_tab" :type="type" />
            </div>
        </div>
        <div class="swiper-scrollbar"></div>
    </div>
</template>

<script>
import _ from 'lodash';
import Swiper, { Navigation } from 'swiper';
import { mapGetters } from 'vuex';

Swiper.use([Navigation]);

export default {
    props: ['contentstream_id', 'contentstream_type_id', 'product_id', 'page', 'query_params', 'active_tab', 'type', 'origin'],

    data: () => ({
        loading: true
    }),
    mounted() {
        this.initContentstreams();
    },

    computed: {
        ...mapGetters('contentstreams', ['getByKey'])
    },

    methods: {
        initContentstreams() {
            this.indexContentstreams({
                key: 'past_analysis',
                except: [this.contentstream_id],
                product_id: [this.product_id],
                contentstream_type_id: [this.contentstream_type_id]
            }).then(() => {
                this.loading = false;
                this.$nextTick(() => {
                    this.init();
                });
            });
        },

        init() {
            new Swiper('.past-analysis-slider', {
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                    nextEl: '.past-analysis-button-next',
                    prevEl: '.past-analysis-button-prev'
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    640: {
                        slidesPerView: 1
                    },
                    768: {
                        slidesPerView: 1
                    },
                    1024: {
                        slidesPerView: 1
                    },
                    1280: {
                        slidesPerView: 1
                    },
                    1536: {
                        slidesPerView: 2
                    }
                }
            });
        },

        async indexContentstreams(params) {
            const config = {
                params: {
                    'sort[by]': 'published_at',
                    'sort[order]': 'desc'
                }
            };

            _.merge(config.params, params);

            this.innerLoading = true;

            return await this.$store.dispatch('contentstreams/index', config).then(() => {
                this.innerLoading = false;
            });
        }
    },

    watch: {
        contentstream_id: function () {
            if (this.$route.params.id) {
                this.initContentstreams();
            }
        }
    }
};
</script>
